import { apiService } from '.';
import { ChannelsInfoWeb } from '../shared/types/modules/channels-web-information';

export const asyncCreateChannelsSurvey = async (
    channelsInfoWeb: ChannelsInfoWeb
): Promise<ChannelsInfoWeb | undefined> => {
    try {
        const {
            items: data,
        }: {
            items: ChannelsInfoWeb;
        } = await apiService.post('/api/channels-web', channelsInfoWeb);
        return data;
    } catch (error) {}
};
